/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationDto } from '../../models/notification-dto';

export interface NotificationAdminControllerFindByIdV1$Params {
  id: string;
}

export function notificationAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: NotificationAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
  const rb = new RequestBuilder(rootUrl, notificationAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationDto>;
    })
  );
}

notificationAdminControllerFindByIdV1.PATH = '/api/v1/notifications/admin/{id}';
